export default __webpack_public_path__ + "static/media/shortrocks.63ece00e.png";